module.exports = __webpack_public_path__ + "img/icon-pay-selected.73db31b0.svg";